import axios from 'axios'

var API_URL = process.env.VUE_APP_URL + '/api/config/'
class ConfigService {
    getAnuncio() {
        return axios.get(API_URL + 'anuncio')
    }

    getCarousel() {
        return axios.get(API_URL + 'carousel')
    }

    getCarouselTexto() {
        return axios.get(API_URL + 'valor-carousel')
    }

    getUtils() {
        return axios.get(API_URL)
    }

    getNotifPed() {
        return axios.get(API_URL + 'notif-ped')
    }

    putNotifPed(mails) {
        return axios.put(API_URL + 'notif-ped?mails=' + mails)
    }

    getNumped() {
        return axios.get(API_URL + 'numped')
    }

    getNumpedCli() {
        return axios.get(API_URL + 'numped/cli')
    }

    checkHabilitado(pag) {
        return axios.get(API_URL + 'habilitado?pag=' + pag)
    }

    getContacto() {
        return axios.get(API_URL + 'contacto')
    }

    guardarPags(config) {
        return axios.put(API_URL + 'utils', config)
    }

    getBannerHab() {
      return axios.get(API_URL + 'bannerhab')
    }

    getBanner() {
        return axios.get(API_URL + 'banner', {
            responseType: 'arraybuffer'
          })
    }

    postBanner(formData) {
      return axios.post(API_URL + 'banner' , formData, {
        headers: {
        'Content-Type': 'multipart/form-data'
        }
      })
    }
}

export default new ConfigService()